import React from 'react';
import { Card } from 'antd';
import { ITheme } from "./themeType";

interface ThemePresetCardProps {
  id: string;
  name: string;
  colors: ITheme;
  isSelected: boolean;
  onClick: () => void;
}

const ThemePresetCard: React.FC<ThemePresetCardProps> = ({
  id,
  name,
  colors,
  isSelected,
  onClick,
}) => {
  return (
    <Card
      hoverable
      onClick={onClick}
      className={`cursor-pointer rounded-xl p-4 transition-all ${
        isSelected
          ? "border-blue-500 ring-2 ring-blue-300"
          : "border-gray-300"
      }`}
      bodyStyle={{ padding: 16 }}
      style={{
        borderRadius: 12,
        borderColor: isSelected ? '#3b82f6' : '#d1d5db',
        boxShadow: isSelected ? '0 0 8px rgba(59, 130, 246, 0.5)' : undefined,
      }}
    >
      <div
        className="h-4 mb-2 rounded"
        style={{ backgroundColor: colors.primary }}
      />
      <div
        className="h-4 mb-2 rounded"
        style={{ backgroundColor: colors.secondary }}
      />
      <div
        className="h-4 mb-2 rounded"
        style={{ backgroundColor: colors.background }}
      />
      <p className="text-center text-sm mt-2">{name}</p>
    </Card>
  );
};

export default ThemePresetCard;
